<template>
    <div class="form-container">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Sites for {{areaName}}</strong>
                    </div>
                    <div v-if="!sitesLoaded" class="form-container">
                        <LoadingSpinner />
                    </div>
                    <div v-if="sitesLoaded" class="form-container">
                        <b-row>
                            <b-col v-for="site in sites" cols="12" sm="12" md="6" v-bind:key="site.id">
                                <b-card :no-body="true" footer-class="px-3 py-2">
                                    <b-card-body class="p-3 clearfix">
                                        <div class="site-logo-container float-left mr-3">
                                            <img v-if="site.logo" v-bind:src="getLogo(site.logo)" class="site-logo"/>
                                            <i v-if="!site.logo" :class="getActiveStatusClass(site)" class="fa fa-bank p-3 font-2xl site-logo"></i>
                                        </div>
                                        <div class="h5 text-warning mb-0">{{site.site_name}}</div>
                                        <div class="text-muted text-uppercase font-weight-bold font-xs">{{site.email}} - {{site.contact_no}}</div>
                                        <b-button class="toggle-select-button" :variant="site.is_selected == '1' ? 'success' : 'outline-primary'" @click="toggleSiteSelect(site.id)">
                                            {{site.is_selected == '1' ? 'Selected' : 'Not Selected'}}
                                        </b-button>
                                    </b-card-body>
                                    <div slot="footer">
                                        <b-link class="font-weight-bold font-xs btn-block text-muted" v-on:click="siteSelected(site)" >Select <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-button variant="primary" @click="selectionCompleted">
                                    <i class="fa fa-check"></i>&nbsp;Selection Complete
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import SitesService from '@/services/sites-service.js';
import LoadingSpinner from '@/components/loadingSpinner/LoadingSpinner';
import { loadFile } from "@/shared/utils";

export default {
    name: 'SitesBlockSelection',
    props: ['area'],
    emits: ['site-selected', 'selection-completed'],
    components: {
        LoadingSpinner: LoadingSpinner
    },
    data () {
        return {
            sitesLoaded: false,
            sites: [],
            areaName: ''
        }
    },
    async created() {
        this.$data.areaName = this.area.area_name || 'Unknown';
        this.$data.sites = await SitesService.getSites(this.area.company_id, this.area.id);
        this.$data.sitesLoaded = true;
    },
    methods: {
        getLogo (fileName) {
          return loadFile(fileName)
        },
        getActiveStatusClass(site) {
            return site.is_active == "1" ? 'bg-success' : 'bg-danger';
        },
        siteSelected(site) {
            this.$emit('site-selected', site);
        },
        toggleSiteSelect(siteId) {
            this.$data.sites = this.$data.sites.map((item) => {
                if (item.id == siteId) {
                    item.is_selected = item.is_selected == 1 ? 0 : 1;
                }
                return item;
            });
        },
        selectionCompleted() {
            const selectedItems = this.$data.sites.filter((item) => {
                return item.is_selected == 1;
            });
            this.$emit('selection-completed', selectedItems);
        }
    }
}

</script>

<style scoped>
.toggle-select-button {
    position: absolute;
    right: 5%;
    top: 15%;
}
div.site-logo-container {
    width: 64px;
    height: 64px;
}
.site-logo {
    max-width: 64px;
    max-height: 64px;
}
</style>